var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SearchYearName',{attrs:{"title":'Corpos Sociais',"minYear":1954,"directory":'corpos_sociais'}})}
var staticRenderFns = []

export { render, staticRenderFns }